import { z } from "zod";

export const questionSchema = z.object({
  id: z.string().min(1),
  prompt: z.string().min(1),
  options: z.array(z.string().min(1)).min(2),
});

export const quizSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  passMark: z.number().int().min(1).max(100),
  questions: z.array(questionSchema).min(1),
});

export const trainingSectionSchema = z.object({
  title: z.string().min(1),
  body: z.string().min(1),
  tip: z.string().min(1).optional(),
});

export const trainingSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
  minutes: z.number().int().positive(),
  skillIds: z.array(z.string().min(1)).min(1),
  sections: z.array(trainingSectionSchema).min(2),
});

export const skillSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  shortTitle: z.string().min(1),
  description: z.string().min(1),
  icon: z.string().min(1),
  trainingId: z.string().min(1),
  assessment: quizSchema,
  test: quizSchema,
});

export const roleSchema = z.object({
  id: z.string().min(1),
  title: z.string().min(1),
  description: z.string().min(1),
  skillIds: z.array(z.string().min(1)).min(1),
});

export const organisationSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  customerName: z.string().min(1),
  location: z.string().min(1),
});

export type Question = z.infer<typeof questionSchema>;
export type Quiz = z.infer<typeof quizSchema>;
export type Training = z.infer<typeof trainingSchema>;
export type Skill = z.infer<typeof skillSchema>;
export type Role = z.infer<typeof roleSchema>;
export type Organisation = z.infer<typeof organisationSchema>;
